/**
 * Sortierung fuer Tabellen (V-16): Zahlen nach Groesse, Texte nach deutschem
 * Alphabet. Leere Werte stehen in beiden Richtungen immer am Ende - eine
 * fehlende Note ist weder die beste noch die schlechteste.
 */
export type SortWert = string | number | null | undefined;
export type Richtung = 'auf' | 'ab';

const vergleich = new Intl.Collator('de', { numeric: true, sensitivity: 'base' });

export function sortiere<T>(zeilen: T[], wert: (z: T) => SortWert, richtung: Richtung): T[] {
  const leer = (v: SortWert) => v === null || v === undefined || v === '' || (typeof v === 'number' && !Number.isFinite(v));
  return zeilen
    .map((z, i) => ({ z, i, v: wert(z) }))
    .sort((a, b) => {
      if (leer(a.v) || leer(b.v)) return leer(a.v) === leer(b.v) ? a.i - b.i : leer(a.v) ? 1 : -1;
      const c = typeof a.v === 'number' && typeof b.v === 'number' ? a.v - b.v : vergleich.compare(String(a.v), String(b.v));
      return (richtung === 'auf' ? c : -c) || a.i - b.i;
    })
    .map((x) => x.z);
}
